import { motion } from "framer-motion";

const services = [
  {
    icon: "./Shape.png",
    title: "Elementbauweise",
    desc: "Bodenplatten und Keller in moderner Elementbauweise",
  },
  {
    icon: "./ruler.png",
    title: "Kernbohrungen",
    desc: "Durchbrüche und Kernbohrungen jeder Größe",
  },
  {
    icon: "./measuring-tool.png",
    title: "Abbrucharbeiten",
    desc: "Sämtliche Abbrucharbeiten professionell durchgeführt",
  },
];

export default function OverHome() {
  return (
    <div className="relative z-10 max-w-6xl mx-auto px-4 -mt-20 md:-mt-32 mb-10">
      <motion.div
        className="bg-white shadow-xl rounded-lg border-t-4 border-darkBlue p-8 md:p-10"
        initial={{ opacity: 0, y: 60 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, margin: "-50px" }}
        transition={{ duration: 0.7 }}
      >
        <h2 className="text-2xl md:text-3xl text-darkBlue font-bold mb-8">
          Wir bauen Gebäude
          <br />
          Neu und Um.
        </h2>
        <div className="flex flex-col md:flex-row gap-8">
          {services.map((service, i) => (
            <motion.div
              key={i}
              className="flex gap-4 items-start flex-1"
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5, delay: i * 0.15 }}
            >
              <img
                className="h-14 w-14 flex-shrink-0"
                src={service.icon}
                alt={service.title}
              />
              <div className="flex flex-col gap-1">
                <h3 className="text-darkBlue text-xl font-bold">
                  {service.title}
                </h3>
                <p className="text-gray-600 text-sm">{service.desc}</p>
              </div>
            </motion.div>
          ))}
        </div>
      </motion.div>
    </div>
  );
}
